import { createSlice, 
         PayloadAction
       }                                        from "@reduxjs/toolkit";
import { RootState }                            from "store/Store";
import { APIData }                              from "types/cms/frontendTypes";

export const CMS_DEFAULT_LOCALE = 'en'

export interface CMSPilotsReducerState {
  pilotList               : APIData<"api::utility.utility">[]
  selectedPilotDocId      : string
  selectedPilotRecoScore ?: APIData<'api::utility-reco-score.utility-reco-score'>
  locales                 : { code : string, name : string }[]  
  initDone                : boolean
}

const defaultState : CMSPilotsReducerState = {
  pilotList       : [],
  selectedPilotDocId : '',
  selectedPilotRecoScore : undefined,
  locales : [],
  initDone : false
}

export const cmsPilotSlice = createSlice({
  name : 'pilots',
  initialState : defaultState,
  reducers : {
    setInitDone : (state, action: PayloadAction<boolean>) => {
      state.initDone = action.payload;
    },
    setCMSPilotList : (state, action: PayloadAction<APIData<"api::utility.utility">[]>) => {
      state.pilotList = action.payload as any;
    },
    upsertCMSPilot : (state, action: PayloadAction<APIData<"api::utility.utility">>) => {
      const existingPilot = state.pilotList.find(pilot => pilot.documentId === action.payload.documentId);
      if (existingPilot) {
        state.pilotList = state.pilotList.map(pilot => pilot.documentId === action.payload.documentId ? action.payload as any : pilot);
      } else {
        state.pilotList.push(action.payload as any);
      }
    },
    selectCMSPilot : (state, action: PayloadAction<{docId : string}>) => {
      state.selectedPilotDocId = action.payload.docId;
    },
    setSelectedPilotRecoScore : (state, action: PayloadAction<APIData<'api::utility-reco-score.utility-reco-score'>>) => {
      state.selectedPilotRecoScore = action.payload as any;
    },
    resetSelectedPilotRecoScore : (state) => {
    state.selectedPilotRecoScore = undefined;
    },
    setLocales : (state, action: PayloadAction<{code : string, name : string }[]>) => {
      state.locales = action.payload;
    }
  }
})

export const {
  setCMSPilotList,
  upsertCMSPilot,
  selectCMSPilot,
  setSelectedPilotRecoScore,
  resetSelectedPilotRecoScore,
  setLocales,
  setInitDone
} = cmsPilotSlice.actions;

export const selectCMSInitDone = (state: RootState) => (state.cmsPilot as CMSPilotsReducerState).initDone;
export const selectCMSPilotList = (state: RootState) => (state.cmsPilot as CMSPilotsReducerState).pilotList;
export const selectCMSSelectedPilot = (state: RootState) => (state.cmsPilot as CMSPilotsReducerState).pilotList.find(pilot => pilot.documentId === state.cmsPilot.selectedPilotDocId);
export const selectCMSSelectedPilotDocId = (state: RootState) => (state.cmsPilot as CMSPilotsReducerState).selectedPilotDocId;
export const selectCMSSelectedPilotRecoScore = (state: RootState) => (state.cmsPilot as CMSPilotsReducerState).selectedPilotRecoScore;
export const selectCMSLocales = (state: RootState) => (state.cmsPilot as CMSPilotsReducerState).locales;